// Copyright (c) 2015-present, salesforce.com, inc. All rights reserved

// # Unprovisioned Homepage Card Info

// ## Dependencies
import { Button, Icon } from '@salesforce/design-system-react';

// ### React
import React from 'react';
import PropTypes from 'prop-types';

function UnprovisionedInfo(props) {
  return (
    <div>
      <Icon className="slds-size--1-of-1 slds-m-bottom--x-large" name="lock" category="utility" size="large" />
      <div>
        <h3 className="slds-section__title slds-m-bottom--small">{props.title}</h3>
        <p className="slds-text-color--weak slds-m-bottom--large">{props.description}</p>
        <Button className="slds-size--1-of-1" label={props.buttonLabel} onClick={props.onButtonClick} />
      </div>
    </div>
  );
}

// ### Display Name
UnprovisionedInfo.displayName = 'HOMEPAGE_UNPROVISIONED_INFO';

// ### Prop Types
UnprovisionedInfo.propTypes = {
  /**
   * Localized label for button
   */
  buttonLabel: PropTypes.string,
  /**
   * Optional descriotion for Unprovisioned Info.
   */
  description: PropTypes.string,
  /**
   * Callback fired when button is clicked
   */
  onButtonClick: PropTypes.func.isRequired,
  /**
   * The title for Unprovisioned Info. Example: "Your account is not provisioned for Email Studio"
   */
  title: PropTypes.node.isRequired,
};

UnprovisionedInfo.defaultProps = {
  buttonLabel: 'View Plan Details',
};

export default UnprovisionedInfo;
